import axiosApi from "../axiosInstance";
import { getReduxCompany, getStoredUser, getStoredCompany } from "../../helper/sessionHelper";

const getAssetMovementList = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;
    const response = await axiosApi.post(
      `/Report/getAssetMovementReport`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error ===> getAssetMovementList", error);
    return error?.response?.data;
  }
};

const getAssetRequestList = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;
    const response = await axiosApi.post(`/Report/getAssetRequestReport`, body);
    return response?.data;
  } catch (error) {
    console.log("Error ===> getAssetRequestList", error);
    return error?.response?.data;
  }
};

const getAssetDispatchList = async (assetDispatchId, userId) => {
  try {
    const response = await axiosApi.get(
      `/Report/getAssetDispatchReport/${assetDispatchId}/${userId}/${
        getStoredCompany()?.companyId || 0
      }`
    );
    return response?.data;
  } catch (error) {
    console.log("Error ===> getAssetDispatchList", error);
    return error?.response?.data;
  }
};

const getAssetScrapList = async (assetScrapId, userId) => {
  try {
    // use provided userId, or fallback to stored user
    const effectiveUserId =
      userId ?? getStoredUser()?.userId ?? getStoredUser()?.id ?? 0;
    const response = await axiosApi.get(
      `/Report/getAssetScrapReport/${assetScrapId}/${
        getStoredCompany()?.companyId || 0
      }/${effectiveUserId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error ===> getAssetScrapList", error);
    return error?.response?.data;
  }
};

const getAssetAcknowledgementList = async (assetAcknowledgeId, userId) => {
  try {
    const effectiveUserId =
      userId ?? getStoredUser()?.userId ?? getStoredUser()?.id ?? 0;
    const response = await axiosApi.get(
      `/Report/getAssetAcknowledgementReport/${assetAcknowledgeId}/${
        getStoredCompany()?.companyId || 0
      }/${effectiveUserId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error ===> getAssetAcknowledgementList", error);
    return error?.response?.data;
  }
};

const getAssetQuotationList = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;
    const response = await axiosApi.post(
      `/Report/getAssetQuotationReport/`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error ===> getAssetQuotationList", error);
    return error?.response?.data;
  }
};

const getAssetMaterialRequestReport = async (materialMrId) => {
  try {
    const response = await axiosApi.get(
      `/Report/getAssetMaterialRequestReport/${materialMrId}/${
        getStoredCompany()?.companyId || 0
      }`
    );
    return response?.data;
  } catch (error) {
    console.log("Error ===> getAssetMaterialRequestReport", error);
    return error?.response?.data;
  }
};

const getAssetMaterialMovementOrderReport = async (materialOrderId, userId) => {
  try {
    const effectiveUserId =
      userId ?? getStoredUser()?.userId ?? getStoredUser()?.id ?? 0;
    const response = await axiosApi.get(
      `/Report/getAssetMaterialMovementOrderReport/${materialOrderId}/${effectiveUserId}/${
        getStoredCompany()?.companyId || 0
      }`
    );
    return response?.data;
  } catch (error) {
    console.log("Error ===> getAssetMaterialMovementOrderReport", error);
    return error?.response?.data;
  }
};

const getAssetAttachmentReport = async () => {
  try {
    const response = await axiosApi.get(`/Report/getAssetAttachmentReport`);
    return response?.data;
  } catch (error) {
    console.log("Error ===> getAssetAttachmentReport", error);
    return error?.response?.data;
  }
};

export const reportService = {
  getAssetMovementList,
  getAssetRequestList,
  getAssetDispatchList,
  getAssetScrapList,
  getAssetAcknowledgementList,
  getAssetQuotationList,
  getAssetMaterialRequestReport,
  getAssetMaterialMovementOrderReport,
  getAssetAttachmentReport,
};
